module.exports = __webpack_public_path__ + "4ae35e4756d7decf53be28cb617160c6.pdf";